import * as React from "react";
import { isMobile } from "@warda/library-ui/utils/deviceUtils";
import InputMobileMultiSearch from "@warda/library-ui/core/InputMobileMultiSearch";
import { ACT_VPORT } from "../reducer";
import { useContextDispatchViewport } from "../SharePage";
import { FILENAME_FILTER_INDEX } from "./constants";
import splitValue from "./utils/splitValue";
import formatAsString from "./utils/formatAsString";
const FilterFileNameMobile = ({ value = "", showClose = true, }) => {
    const [inputValue, setInputValue] = React.useState(formatAsString(value));
    const dispatchViewport = useContextDispatchViewport();
    const cbOnCloseSearch = React.useCallback(() => {
        dispatchViewport({ type: ACT_VPORT.VIEW_MODE_NAVIGA });
    }, [dispatchViewport]);
    const cbOnFocusSearch = React.useCallback(() => {
        dispatchViewport({ type: ACT_VPORT.VIEW_MODE_SEARCH });
    }, [dispatchViewport]);
    const cbOnChangeFilter = React.useCallback((value) => {
        setInputValue(value);
        dispatchViewport({
            type: ACT_VPORT.FILTER,
            clearAll: false,
            index: FILENAME_FILTER_INDEX,
            value: splitValue(value),
        });
    }, [dispatchViewport, setInputValue]);
    if (!isMobile())
        return null;
    return (React.createElement(InputMobileMultiSearch, { showClose: showClose, onClose: cbOnCloseSearch, onFocus: cbOnFocusSearch, onChange: cbOnChangeFilter, placeholder: "Search in Sharepage...", value: inputValue, maxRows: 4 }));
};
export default FilterFileNameMobile;
